// extracted by mini-css-extract-plugin
var _1 = "FileErrorTooLargeModalContent-moduleTooLargeFiles__gFnpY";
export { _1 as "TooLargeFiles" }
